// extracted by mini-css-extract-plugin
export default {"div":"ComingSoon_div__v9vj3","sDiv":"ComingSoon_sDiv__lihiv"};